export enum ProviderType {
  Google = 1,
  Microsoft = 2,
  Apple = 3,
  Slack = 4,
  Facebook = 5,
  Password = 6,
  Zoom = 7,
  Salesforce = 8,
  Line = 9,
  Teams = 10,
  HubSpot = 11,
  Notion = 12,
  GoogleSheet = 13,
}

export enum IntegrationType {
  GoogleCalendar = 1,
  Outlook = 2,
  iCloudCalendar = 3,
  Slack = 4,
  Facebook = 5,
  GoogleAnalytics = 6,
  Zoom = 7,
  Stripe = 8,
  Teams = 9,
  Zapier = 10,
  Salesforce = 11,
  HubSpot = 12,
  Notion = 13,
  SearchEngine = 14,
  Webhook = 15,
  SMS = 16,
  GoogleMeet = 17,
  GoogleWorkspace = 18,
  Assistant = 19,
  GoogleSheet = 20,
  LinkAccount = 21,
  NotionForm = 22,
  MetaPixel = 23,
  Api = 25,
  None = 999,
}

export const isAdminRequired = (integrationType: IntegrationType) => {
  return [
    IntegrationType.Salesforce,
    IntegrationType.Stripe,
    IntegrationType.HubSpot,
  ].includes(integrationType);
};

export enum Provider {
  Google = 'google.com',
  Microsoft = 'microsoft.com',
  Apple = 'apple.com',
  Slack = 'slack.com',
  Facebook = 'facebook.com',
  Salesforce = 'salesforce.com',
  Password = 'password',
  Teams = 'teams.com',
  Line = 'line.me',
}

export const providerTypeToProvider = (providerType: ProviderType) => {
  switch (providerType) {
    case ProviderType.Google:
    case ProviderType.GoogleSheet:
      return Provider.Google;
    case ProviderType.Microsoft:
      return Provider.Microsoft;
    case ProviderType.Apple:
      return Provider.Apple;
    case ProviderType.Slack:
      return Provider.Slack;
    case ProviderType.Facebook:
      return Provider.Facebook;
    case ProviderType.Salesforce:
      return Provider.Salesforce;
    case ProviderType.Password:
      return Provider.Password;
    case ProviderType.Line:
      return Provider.Line;
    default:
      break;
  }
  return null;
};

export const providerTypeToIntegrationTypes = (providerType: ProviderType) => {
  switch (providerType) {
    case ProviderType.Google:
      return [IntegrationType.GoogleCalendar];
    case ProviderType.Microsoft:
      return [IntegrationType.Outlook];
    case ProviderType.Slack:
      return [IntegrationType.Slack];
    case ProviderType.Zoom:
      return [IntegrationType.Zoom];
    case ProviderType.Teams:
      return [IntegrationType.Teams];
    case ProviderType.Apple:
      return [IntegrationType.iCloudCalendar];
    case ProviderType.Facebook:
      return [IntegrationType.Facebook];
    case ProviderType.Salesforce:
      return [IntegrationType.Salesforce];
    case ProviderType.HubSpot:
      return [IntegrationType.HubSpot];
    case ProviderType.Notion:
      return [IntegrationType.Notion, IntegrationType.NotionForm];
    case ProviderType.GoogleSheet:
      return [IntegrationType.GoogleSheet];
    default:
      return [];
  }
};

export const providerTypeIconPath = (providerType: ProviderType) => {
  switch (providerType) {
    case ProviderType.Google:
    case ProviderType.GoogleSheet:
      return 'account/google.svg';
    case ProviderType.Facebook:
      return 'account/facebook.svg';
    case ProviderType.Microsoft:
      return 'account/microsoft.svg';
    case ProviderType.Apple:
      return 'account/apple.svg';
    case ProviderType.Salesforce:
      return 'account/salesforce.svg';
    case ProviderType.Password:
      return 'logo/symbol.svg';
    case ProviderType.Line:
      return 'account/line.svg';
    default:
      break;
  }
  return '';
};

export const providerTypeName = (providerType: ProviderType) => {
  switch (providerType) {
    case ProviderType.Password:
      return 'Jicoo';
    case ProviderType.Google:
    case ProviderType.GoogleSheet:
      return 'Google';
    case ProviderType.Facebook:
      return 'Facebook';
    case ProviderType.Microsoft:
      return 'Microsoft';
    case ProviderType.Apple:
      return 'Apple';
    case ProviderType.Slack:
      return 'Slack';
    case ProviderType.Zoom:
      return 'Zoom';
    case ProviderType.Line:
      return 'Line';
  }
};

export const calendarProviderTypes = [
  ProviderType.Google,
  ProviderType.Microsoft,
  ProviderType.Apple,
];

export const resourceProviderTypes = [ProviderType.Google];
